(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("cfehG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42737bbb065d20a9$export$2e2bcd8739ae039; });

var $2hYdk = parcelRequire("2hYdk");

var $3tZSl = parcelRequire("3tZSl");
const $42737bbb065d20a9$var$sweedDataSource = ()=>{
    (0, $3tZSl.datalayerSource)((data)=>{
        if (data.event === "purchase") {
            console.log("Purchase Event: ", data);
            try {
                const transaction = data && data.ecommerce;
                const products = transaction.items;
                const { value: value, shipping: shipping, tax: tax } = transaction;
                const transactionId = transaction && transaction.transaction_id && transaction.transaction_id.toString();
                (0, $2hYdk.default).notify({
                    transactionEvent: {
                        id: transactionId,
                        total: parseFloat(value),
                        tax: parseFloat(tax),
                        city: "N/A",
                        country: "USA",
                        currency: "USD",
                        shipping: shipping,
                        state: "N/A",
                        items: products.map((items)=>{
                            const { item_id: item_id, item_name: item_name, item_category: item_category, price: price, quantity: quantity } = items;
                            return {
                                orderId: transactionId,
                                category: item_category,
                                currency: "USD",
                                name: item_name,
                                quantity: quantity,
                                sku: item_id,
                                unitPrice: parseFloat(price) || 0
                            };
                        })
                    }
                });
            } catch (error) {
                console.log("Log Warn Purchase Event: ", error);
            }
        }
        if (data.event === "add_to_cart") try {
            var _products_item_name, _products_item_category;
            const transaction = data && data.ecommerce;
            const products = transaction === null || transaction === void 0 ? void 0 : transaction.items[0];
            (0, $2hYdk.default).notify({
                addToCartEvent: {
                    sku: products === null || products === void 0 ? void 0 : products.item_id.toString(),
                    name: (products === null || products === void 0 ? void 0 : (_products_item_name = products.item_name) === null || _products_item_name === void 0 ? void 0 : _products_item_name.toString()) || "N/A",
                    category: (products === null || products === void 0 ? void 0 : (_products_item_category = products.item_category) === null || _products_item_category === void 0 ? void 0 : _products_item_category.toString()) || "N/A",
                    unitPrice: parseFloat((products === null || products === void 0 ? void 0 : products.price) || 0),
                    quantity: parseInt((products === null || products === void 0 ? void 0 : products.quantity) || 1),
                    currency: "USD"
                }
            });
        } catch (error) {
            console.log("Log Warn Add to Cart Event: ", error);
        }
        if (data.event === "remove_from_cart") try {
            var _products_item_name1, _products_item_category1;
            const transaction = data && data.ecommerce;
            const products = transaction === null || transaction === void 0 ? void 0 : transaction.items[0];
            (0, $2hYdk.default).notify({
                removeFromCartEvent: {
                    sku: products === null || products === void 0 ? void 0 : products.item_id.toString(),
                    name: (products === null || products === void 0 ? void 0 : (_products_item_name1 = products.item_name) === null || _products_item_name1 === void 0 ? void 0 : _products_item_name1.toString()) || "N/A",
                    category: (products === null || products === void 0 ? void 0 : (_products_item_category1 = products.item_category) === null || _products_item_category1 === void 0 ? void 0 : _products_item_category1.toString()) || "N/A",
                    unitPrice: parseFloat((products === null || products === void 0 ? void 0 : products.price) || 0),
                    quantity: parseInt((products === null || products === void 0 ? void 0 : products.quantity) || 1),
                    currency: "USD"
                }
            });
        } catch (error) {
            console.log("Log Warn Remove from Cart Event: ", error);
        }
    });
};
var $42737bbb065d20a9$export$2e2bcd8739ae039 = $42737bbb065d20a9$var$sweedDataSource;

});
parcelRegister("3tZSl", function(module, exports) {

$parcel$export(module.exports, "datalayerSource", function () { return $e91c32e4cc07a5e4$export$fa083663fc42253f; });
const $e91c32e4cc07a5e4$export$fa083663fc42253f = (callback, dataLayer = window.dataLayer || [])=>{
    // dataLayer is optional second param to handle dispense cart;
    if (!dataLayer || typeof dataLayer.push !== "function") {
        console.error("dataLayer.push is not a function");
        return;
    }
    const originalPush = dataLayer.push.bind(dataLayer);
    dataLayer.push = (...args)=>{
        originalPush(...args);
        callback(dataLayer.slice(-1)[0]); // Gets the newest array member of dataLayer
    };
};

});


})();
//# sourceMappingURL=sweed.525392d9.js.map
